import { getFormValues } from 'redux-form'
import { COMMUNICATION_PREFERENCES_FORM } from './constants'

export const getProvidePhoneNumberFormValues = getFormValues(COMMUNICATION_PREFERENCES_FORM)
